// extracted by mini-css-extract-plugin
export default {"uspContainer":"USP-module__uspContainer--qYXb","uspList":"USP-module__uspList--HB4n","uspItem":"USP-module__uspItem--DW6U","checkCircle":"USP-module__checkCircle--x1BZ"};